import React, { useEffect, useState } from 'react'
import SidebarMenuComponent from './SidebarMenuComponent/SidebarMenuComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import { hasPrivilege, isModulePermitted } from '../../utils/privileges';
import { useDispatch, useSelector } from 'react-redux';
import { setPrivileges } from '../../features/privileges/privilegesSlice';
import { get_privilages } from '../../config/GeneralApis/privilegeApis';
import { Icons } from '../../utils/GlobalIcons';
import { getUserRoleFlags } from '../../utils/userRoleUtils';


function Sidebar({ handleLogoutClick, toggleSidebar }) {
    const dispatch = useDispatch();
    const location = useLocation();

    const privileges = useSelector((state) => state.privileges.privileges);

    // SUPER ADMIN 1 
    // 2 = SUPERVISOR
    // 6 = FINANCE 24= MAIN FINANCE

    const { isSuperAdmin, isSupervisor, isAllFinance, isManagement } = getUserRoleFlags()

    const [activeMenu, setActiveMenu] = useState(null); // Track active menu

    // Extract active menu value from location.pathname
    const extractActiveMenu = (pathname) => {
        const segments = pathname.split('/');
        return segments[1]; // The first segment in the pathname corresponds to the active menu
    };

    // FOR CURRENT ACTIVE MENU
    useEffect(() => {
        const active = extractActiveMenu(location.pathname);
        setActiveMenu(active);
    }, [location.pathname, setActiveMenu]);

    //SIDEBAR MENUS
    const menuData = [
        {
            id: 1,
            text: 'Dashboard',
            icon: <Icons.Dashboard />,
            permission: true, // User has access to this menu
            menus: [
                {
                    link: 'dashboard/dashboard/overview',
                    permission: true, // User has access
                },
            ],
        },
        {
            id: 2,
            text: 'Worksites',
            icon: <Icons.Worksites />,
            permission: isModulePermitted(privileges, "Work site"), // User has access to Worksites
            menus: [
                {
                    submenus: [
                        { name: 'Projects', link: 'worksites/projects/overview', icon: <Icons.Projects />, permission: hasPrivilege(privileges, "Work site", 1, 2) },
                        { name: 'Sites', link: 'worksites/worksites/overview', icon: <Icons.Sites />, permission: hasPrivilege(privileges, "Work site", 2, 2) },  // No access
                        { name: 'Schedules', link: 'worksites/schedule/overview', icon: <Icons.WorksiteSchedules />, permission: hasPrivilege(privileges, "Work site", 3, 2), },
                        { name: 'My Schedules', link: 'worksites/my-schedules/overview', icon: <Icons.WorksiteSchedules />, permission: isSupervisor }, // role id 2 = superviosr

                    ],
                },
            ],
        },
        {
            id: 3,
            text: 'Resources',
            icon: <Icons.Resources />,
            permission: isModulePermitted(privileges, "Resources"), // User does not have access to Resources
            menus: [
                {
                    submenus: [
                        { name: 'Technology', link: 'resources/technologies/list', icon: <Icons.Technology />, permission: hasPrivilege(privileges, "Resources", 4, 2), },
                        { name: 'Equipment', link: 'resources/equipment/list', icon: <Icons.Equipment />, permission: hasPrivilege(privileges, "Resources", 5, 2), },
                        { name: 'Workforce', link: 'resources/workforce/list', icon: <Icons.Workforce />, permission: hasPrivilege(privileges, "Resources", 6, 2), },
                    ],
                },
            ],
        },
        {
            id: 4,
            text: 'Reports',
            icon: <Icons.Reports />,
            permission: isModulePermitted(privileges, "Reports"),
            menus: [
                {
                    submenus: [
                        { name: 'Employee', link: 'reports/reports/employee-management', icon: <Icons.EmployeeReport />, permission: hasPrivilege(privileges, "Reports", 23, 2), },
                        { name: 'Project', link: 'reports/reports/project-management', icon: <Icons.ProjectReport />, permission: hasPrivilege(privileges, "Reports", 24, 2), },
                        { name: 'Monthly', link: 'reports/reports/monthly-report', icon: <Icons.Calender />, permission: false }, // No access

                        { name: 'Equipment ', link: 'reports/reports/equipment-report', icon: <Icons.Equipment />, permission: hasPrivilege(privileges, "Reports", 25, 2), },
                        { name: 'Worksite ', link: 'reports/reports/worksite-report', icon: <Icons.WorksiteReport />, permission: hasPrivilege(privileges, "Reports", 26, 2), },
                        { name: 'Invoice ', link: 'reports/reports/invoice-report', icon: <Icons.InvoiceReport />, permission: hasPrivilege(privileges, "Reports", 27, 2), }, // No access

                        { name: 'Employee Future Schedule ', link: 'reports/employee/schedule', icon: <Icons.EmployeeFutureSchedule />, permission: hasPrivilege(privileges, "Reports", 28, 2), },
                        { name: 'Employee Utilization ', link: 'reports/employee/utilization', icon: <Icons.EmployeeUtilization />, permission: hasPrivilege(privileges, "Reports", 30, 2), },
                        { name: 'Equipment Utilization ', link: 'reports/equipment/utilization', icon: <Icons.EquipmentUtilization />, permission: hasPrivilege(privileges, "Reports", 31, 2), }, // No access

                    ],
                },
            ],
        },
        {
            id: 5,
            text: 'Settings',
            icon: <Icons.Settings />,
            permission: isModulePermitted(privileges, "Settings"),
            menus: [
                {
                    submenus: [
                        { name: 'Roles', link: 'settings/role/list', icon: <Icons.RoleSettings />, permission: hasPrivilege(privileges, "Settings", 10, 2), },
                        { name: 'Designation', link: 'settings/designation/list', icon: <Icons.DesignationSettings />, permission: hasPrivilege(privileges, "Settings", 11, 2), },
                        { name: 'Classification', link: 'settings/classification/list', icon: <Icons.ClassificationSettings />, permission: hasPrivilege(privileges, "Settings", 11, 2), },

                        { name: 'Leave', link: 'settings/leaveType/list', icon: <Icons.LeaveSettings />, permission: hasPrivilege(privileges, "Settings", 12, 2), },
                        { name: 'Category Level', link: 'settings/category/list', icon: <Icons.CategoryLevelSettings />, permission: hasPrivilege(privileges, "Settings", 13, 2), },
                        { name: 'Holiday', link: 'settings/holiday/view', icon: <Icons.HolidaySettings />, permission: hasPrivilege(privileges, "Settings", 14, 2), },
                        { name: 'Roles & Permissions', link: '/settings/RolesPermissions', icon: <Icons.RolesPermissions />, permission: hasPrivilege(privileges, "Settings", 15, 2), },
                        { name: 'Email Assign', link: '/settings/EmailNotificationAssign', icon: <Icons.EmailNotification />, permission: hasPrivilege(privileges, "Settings", 15, 2), },
                    ],
                },
            ],
        },

        {
            id: 6,
            text: 'Schedule',
            icon: <Icons.Schedule />,
            permission: isModulePermitted(privileges, "Schedule"),
            menus: [
                {
                    submenus: [
                        { name: 'FSE Calender', link: 'schedule/fse-calendar/view', icon: <Icons.BinReport />, permission: isSupervisor || isManagement, },
                        { name: 'Report Bin', link: 'schedule/bin-report/list', icon: <Icons.BinReport />, permission: hasPrivilege(privileges, "Schedule", 32, 2), },
                        { name: 'Reports', link: 'schedule/report/list', icon: <Icons.ScheduleReports />, permission: hasPrivilege(privileges, "Schedule", 18, 2), },
                        { name: `${!isSupervisor ? `Man-Days (Supervisor)` : `Man-Days`}`, link: 'schedule/kpi/list', icon: <Icons.FSEKPI />, permission: hasPrivilege(privileges, "Schedule", 19, 2), },

                    ],
                },
            ],
        },
        {
            id: 7,
            text: 'Finance',
            icon: <Icons.FinanceReview />,
            permission: isModulePermitted(privileges, "Finances"),
            menus: [
                {
                    submenus: [
                        { name: `${!isAllFinance ? `Man-Days (Finance)` : `Man-Days`}`, link: 'finance/Finance/list', icon: <Icons.FinanceReview />, permission: hasPrivilege(privileges, "Finances", 20, 2), },
                        { name: 'Invoice', link: 'finance/invoice/list', icon: <Icons.ScheduleInvoice />, permission: hasPrivilege(privileges, "Finances", 21, 2), },

                    ],
                },
            ],
        },
        {
            id: 8,
            text: 'Leave',
            icon: <Icons.Leave />,
            permission: isModulePermitted(privileges, "Leave"),
            menus: [
                {
                    submenus: [
                        { name: 'All Leaves ', link: 'leave/leave/list', icon: <Icons.AllLeaves />, permission: hasPrivilege(privileges, "Leave", 16, 2), },
                        { name: 'Leave Calender ', link: 'leave/leave/calender', icon: <Icons.LeaveCalender />, permission: hasPrivilege(privileges, "Leave", 17, 2), },
                        { name: 'Compensation Leave  ', link: 'leave/compensation/Leave', icon: <Icons.Compensation />, permission: hasPrivilege(privileges, "Leave", 33, 2), },
                    ],
                },
            ],
        },
        {
            id: 9,
            text: 'Auditlogs',
            icon: <Icons.Auditlogs />,
            permission: isSuperAdmin,// isModulePermitted(privileges, "Auditlogs"),
            menus: [
                {
                    link: '/auditlogs/overview',
                    permission: isSuperAdmin, // User has access
                },
            ],
        },
        {
            id: 10,
            text: 'Logout',
            icon: <Icons.Logout />,
            permission: true,
            menus: [
                {
                    link: 'logout',
                    permission: true,
                },
            ],
        },

    ];

    // FOR FILTERING MENUS WITH PRIVILEGES
    const filterMenuData = (menuData) => {
        return menuData
            .filter(menu => menu.permission) // Remove menus without access
            .map(menu => ({
                ...menu,
                menus: menu.menus?.map(menuItem => ({
                    ...menuItem,
                    submenus: menuItem.submenus?.filter(submenu => submenu.permission), // Remove inaccessible submenus
                })).filter(menuItem => menuItem.submenus?.length > 0 || menuItem.permission), // Remove empty submenu menus
            }));
    };

    // FOR FILTERED MENUS WITH PRIVILEGES
    const filteredMenuData = filterMenuData(menuData);

    useEffect(() => {
        const fetchPrivileges = async () => {
            try {
                const permissionResponse = await get_privilages(); //GET PRIVILEGES DETAILS
                dispatch(setPrivileges(permissionResponse));
            } catch (error) {
                console.error("Error fetching privileges:", error);
            }
        };
        fetchPrivileges();
    }, []);

    return (
        < >
            {filteredMenuData?.map((item, index) => (
                <SidebarMenuComponent
                    key={item?.id}
                    menu={item}
                    icon={item.icon}
                    text={item.text}
                    mainMenu={item.menus}
                    activeMenu={activeMenu}
                    handleLogoutClick={handleLogoutClick}
                    toggleSidebar={toggleSidebar}
                />
            ))}
        </>
    )
}

export default Sidebar